var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{staticClass:"model-radio",attrs:{"min":1},on:{"change":_vm.handleChange},model:{value:(_vm.checkedId),callback:function ($$v) {_vm.checkedId=$$v},expression:"checkedId"}},_vm._l((_vm.roleTypes),function(role){return _c('el-radio',{key:role.id,attrs:{"label":role.id}},[_vm._v(_vm._s(role.name))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3da728","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio-input.vue
// module id = null
// module chunks = 